import { SMILES_COOKIE_NAME, SMILES_COOKIE_TTL_DAYS } from '@/src/constants/smiles'
import type { SmilesSessionCookie } from '@/src/types/smiles'
import { deleteCookie, getCookie, setCookie } from '@/src/utils/browser'

// authToken is never persisted; the cookie carries only attribution and has a short TTL.
export const readSmilesSession = (): SmilesSessionCookie | null => {
    const raw = getCookie(SMILES_COOKIE_NAME)
    if (!raw) return null

    try {
        const { accountNumber = '', verificationStatus = 'IDLE' } = JSON.parse(decodeURIComponent(raw)) || {}
        return { accountNumber, verificationStatus }
    } catch {
        return null
    }
}

export const writeSmilesSession = (session: SmilesSessionCookie): void => {
    setCookie(SMILES_COOKIE_NAME, encodeURIComponent(JSON.stringify(session)), SMILES_COOKIE_TTL_DAYS)
}

export const clearSmilesSession = (): void => deleteCookie(SMILES_COOKIE_NAME)

// Active only for a verified session — a PENDING/FAILED cookie must not attribute the booking.
export const isSmilesSessionActive = (): boolean => readSmilesSession()?.verificationStatus === 'SUCCESS'
